class FacetsGridColumnSwitcher extends HTMLElement {
    constructor() {
        super();
        this.handleResize = this.handleResize.bind(this);
    }

    connectedCallback() {
        if (window.innerWidth < 1000) {
            // document.addEventListener('DOMContentLoaded', this.init.bind(this));
            this.init();
            subscribe(PUB_SUB_EVENTS.facetsUpdate, (payload) => { this.init() });
        }

        // window.addEventListener('resize', this.handleResize);
    }

    handleResize() {
        if (window.innerWidth >= 1000) {
            this.setMobileGridToOneColumn();
        }
    }

    init() {
        this.columnSwitcher1 = document.getElementById('columnSwitcher1');
        this.columnSwitcher2 = document.getElementById('columnSwitcher2');
        this.productGrid = document.querySelector('ul#product-grid');

        if (!this.columnSwitcher1 || !this.columnSwitcher2 || !this.productGrid) return;

        this.columnSwitcher2.addEventListener('click', this.setMobileGridToTwoColumns.bind(this));
        this.columnSwitcher1.addEventListener('click', this.setMobileGridToOneColumn.bind(this));

        this.setup();
    }

    setup() {
        let mode = sessionStorage.getItem('mobileGridColumns');
        switch (mode) {
            case '1':
                this.setMobileGridToOneColumn();
                break;
            case '2':
                this.setMobileGridToTwoColumns();
                break;
            default:
                this.setMobileGridToOneColumn();
                break;
        }
    }

    setMobileGridToOneColumn() {
        if (this.productGrid && !this.productGrid.classList.contains('tw-grid-cols-1')) {
            this.productGrid.classList.remove('tw-grid-cols-2');
            this.productGrid.classList.add('tw-grid-cols-1');
        }

        this.columnSwitcher1.querySelectorAll('rect').forEach((rect) => rect.setAttribute('fill', '#45423D'));
        this.columnSwitcher2.querySelectorAll('rect').forEach((rect) => rect.setAttribute('fill', '#B4B3B1'));

        sessionStorage.setItem('mobileGridColumns', '1');

        this.hideBadges(false);
        this.replaceColorSwatchesWithLabel(false);
    }

    setMobileGridToTwoColumns() {
        if (this.productGrid && !this.productGrid.classList.contains('tw-grid-cols-2')) {
            this.productGrid.classList.remove('tw-grid-cols-1');
            this.productGrid.classList.add('tw-grid-cols-2');
        }

        this.columnSwitcher2.querySelectorAll('rect').forEach((rect) => rect.setAttribute('fill', '#45423D'));
        this.columnSwitcher1.querySelectorAll('rect').forEach((rect) => rect.setAttribute('fill', '#B4B3B1'));

        sessionStorage.setItem('mobileGridColumns', '2');

        this.hideBadges(true);
        this.replaceColorSwatchesWithLabel(true);
    }

    hideBadges(hide) {
        const badges = this.productGrid.querySelectorAll('.badge__wrapper');
        badges.forEach((badge) => {
            if (hide) {
                badge.classList.add('tw-invisible');
            } else {
                badge.classList.remove('tw-invisible');
            }
        });
    }

    replaceColorSwatchesWithLabel(replace) {
        const colorSwatches = this.productGrid.querySelectorAll('query-swatch');
        const colorCountLabels = this.productGrid.querySelectorAll('.color-count');

        colorSwatches.forEach((colorSwatch) => {
            if (replace) {
                colorSwatch.classList.add('tw-hidden');
            } else {
                colorSwatch.classList.remove('tw-hidden');
            }
        });

        colorCountLabels.forEach((label) => {
            if (replace) {
                label.classList.remove('tw-hidden');
            } else {
                label.classList.add('tw-hidden');
            }
        });
    }
}

customElements.define('facets-grid-column-switcher', FacetsGridColumnSwitcher);
